<template>
<section id="contact">
    <h1 class="hover-3">Contact Us</h1>
    <div class="container">
        <form @submit.prevent="handleSubmit" class="form">
            <div class="form-group">
                <label for="fullName">Full name:</label>
                <input type="text" id="fullName" v-model="name" class="form-control input-field">
            </div>

            <div class="form-group">
                <label for="email">Email:</label>
                <input type="email" id="email" v-model="email" class="input-field">
            </div>

            <div class="form-group">
                <label for="message">Message:</label>
                <textarea id="message" rows="5" v-model="message" class="textarea-field"></textarea>
            </div>

            <button type="submit" class="submit-button">Submit</button>
        </form>
    </div>
</section>
</template>

<style scoped>
/* CSS for responsive design */
.input-field:hover {
    background-color: #f5f5f5;
    /* Change to your desired hover background color */
    /* Add any other hover styles here */
}

label{
    font-weight: bold;
}

section {
    background-color: #f9f9f9;
    padding: 40px 0;
    text-align: center;
    animation: fadeIn 1s ease-in-out;
    /* Fade-in animation */
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

h1 {
    font-size: 36px;
    margin-bottom: 20px;
    color: #333;
}

.container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
}

.form {
    background: linear-gradient(to left top, #5effb7, #dba6fe);
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.form-group {
    margin-bottom: 20px;
}

.input-field,
.textarea-field {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
}

.submit-button {
    background-color: #007bff;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 18px;
    transition: background-color 0.3s ease;
    /* Hover effect */
}

.submit-button:hover {
    background-color: #4dda70;
}

/* Media Query for Smaller Screens */
@media (max-width: 768px) {
    h1 {
        font-size: 24px;
    }

    .form {
        padding: 10px;
    }

    .input-field,
    .textarea-field {
        font-size: 14px;
    }

    .submit-button {
        padding: 8px 16px;
        font-size: 16px;
    }

    .result h2 {
        font-size: 20px;
    }
}

.hover-3 {
    --b: 0.1em;
    /* the thickness of the line */
    --c: #0fcd71;
    /* the color */

    color: #0000;
    padding-block: var(--b);
    background:
        linear-gradient(var(--c) 50%, #000 0) 0% calc(100% - var(--_p, 0%))/100% 200%,
        linear-gradient(var(--c) 0 0) 0% var(--_p, 0%)/var(--_p, 0%) var(--b) no-repeat;
    -webkit-background-clip: text, padding-box;
    background-clip: text, padding-box;
    transition: .3s var(--_s, 0s) linear, background-size .3s calc(.3s - var(--_s, 0s));
}

.hover-3:hover {
    --_p: 100%;
    --_s: .5s;
}
</style>






<script>
// Your Vue component

import {
    projectFirestore
} from '../firebase/config';
import {
    collection,
    addDoc
} from 'firebase/firestore';

export default {
    data() {
        return {
            name: '',
            email: '',
            message: ''
        }
    },
    methods: {
        async handleSubmit() {
            try {
                const myCollectionRef = collection(projectFirestore, 'myCollectionName');
                const userMessage = {
                    name: this.name,
                    email: this.email,
                    message: this.message
                };
                await addDoc(myCollectionRef, userMessage);
                // Add any success logic here
            } catch (error) {
                console.error('Error submitting data to Firestore:', error);
            }
        }
    }
}
</script>
